import { render } from "./TheCartOrderComment.vue?vue&type=template&id=488e5a55"
import script from "./TheCartOrderComment.vue?vue&type=script&lang=js"
export * from "./TheCartOrderComment.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__